export enum EHologramGraphAStarResult {
  HologramSearchFail,
  HologramSearchSuccess,
  HologramGoalUnreachable,
  HologramSearchInfiniteLoop,
}
